import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { MainLayout } from 'components/designSystem/layout/MainLayout/MainLayout'
import incognito from 'components/designSystem/svg/promo-incognito.svg'
import { Direction } from 'components/page/RatingWave/Rating.types'

export const Incognito: FC<{
  onHandleClick?: (direction: Direction) => void
}> = ({ onHandleClick }) => {
  const handlePrimaryClick = () => {
    onHandleClick?.(Direction.right)
  }
  const handleSecondaryClick = () => {
    onHandleClick?.(Direction.left)
  }

  return (
    <MainLayout
      title={
        <FormattedMessage
          id="message.title.incognito"
          defaultMessage="Ты инкогнито"
        />
      }
      description={
        <FormattedMessage
          id="message.description.incognito"
          defaultMessage="Твои фото от всех скрыты! Хочешь, чтобы тебя заметили? Отключи режим инкогнито"
        />
      }
      icon={<img src={incognito} width={200} height={200} draggable={false} />}
      backButtonVisible={false}
      onPrimaryButtonClick={handlePrimaryClick}
      onSecondaryButtonClick={handleSecondaryClick}
      primaryButtonText={
        <FormattedMessage id="app.turn_off" defaultMessage="Отключить" />
      }
      primaryButtonDataName="incognito-off-action"
      secondaryButtonText={
        <FormattedMessage id="app.not_now" defaultMessage="Не сейчас" />
      }
      secondaryButtonDataName="incognito-ignore-action"
      secondaryButtonColor="accent"
      increasePaddingBottom={true}
      noBorder={true}
      wrapperStyle={incognitoBackgroundStyle}
    />
  )
}

const incognitoBackgroundStyle = {
  backgroundColor: 'var(--background-surface-2)',
}
